module.exports = __webpack_public_path__ + "static/media/Demeter.0d355eac.jpg";